import { PAGE } from '../../domain';
import { getForm } from '../common/utils';
import { getAppProps, getCartPageURL, setMouseLoading } from '../../utils';
import { getTargetProductId } from '../../utils/item';
import { fetchProductDetail } from '../../getAddOnDetails';
import { showDefaultError } from '../../utils/error';
import {
  DISCOUNT_OFFER_OPTIONS,
  getAddons,
  getDiscountOfferSettings,
  getOptions,
  isValidOptions
} from '../../common/discountOffer';

const styles = `
<style>
  .discountOffer__Wrap {
    padding-top: 20px;
    width: 100%;
    display: flex;
  }
  
  .discountOffer__Widget {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
  
  .discountOffer__Title {
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
    color: rgb(33, 43, 54);
    text-align: center;
  }
  
  .discountOfferBlock__Main {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    -webkit-box-pack: center;
    justify-content: center;
    position: relative;
  }
  
  .discountOfferMain {
    width: 100%;
    display: flex;
    min-height: 82px;
    align-items: flex-start;
    flex-direction: column;
    border-radius: 2px;
    margin-bottom: 10px;
    padding: 20px;
    position: relative;
    background: rgba(81, 95, 188, 0.1);
    border: 2px solid rgb(81, 95, 188);
  }
  
  .discountOfferContainer {
    display: flex;
    width: 100%;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
  }
  
  .discountOfferBlockContainer {
    display: flex;
    flex-direction: column;
  }
  
  .discountOfferBlockContainer__Button {
    background: rgb(81, 95, 188);
    color: rgb(255, 255, 255);
    border-radius: 0px;
    padding: 10px;
    width: 100%;
    height: 48px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    letter-spacing: 0.1em;
    font-weight: bold;
    cursor: pointer;
    user-select: none;
  }
  
  .discountOfferBlockContainer__Text {
    display: -webkit-box;
    margin: 0px auto;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
    overflow: hidden;
  }
  
  .discountOfferBlockRow {
    display: flex;
    align-items: center;
    padding: 5px;
  }
  
  .discountOffferBlockRow__Image {
    width: 60px;
    margin-left: 5px;
  }
  
  .discountOfferBlockRow__Title {
    margin-left: 10px;
  }
</style>
`;

const CONTAINER_ID = 'discountOfferBlockMainRender';
const RADIO_GROUP_ID = 'option_discount_offer';

function injectStyles() {
  document.querySelector('head').insertAdjacentHTML('beforeend', styles);
}

function renderTitle() {
  return `
    <p class="discountOffer__Title">
        Buy more and save
    </p>
  `;
}

function renderAddon(id, data) {
  const { title, image } = data;

  return `
  <div class="discountOfferBlockRow">
    #${id}
    <img class="discountOffferBlockRow__Image" src=${image.src} alt="icon">
    <div class="discountOfferBlockRow__Title">
        ${title}
    </div>
  </div>
  `;
}

async function renderAddons(optionId, addons) {
  window.upsell.discountOffersInfo[optionId] = {};

  let id = 0;
  const promisesList = [];
  const htmls = {};

  for (const handle in addons) {
    const processAddon = (orderId) => {
      const promise = new Promise(resolve => {
        fetchProductDetail(
          handle,
          function(result) {
            const product = result.product;
            const html = renderAddon(orderId, result.product);
            htmls[orderId] = html;
            const [_, variantId] = handle.split('|');
            if (variantId){
              product.variant_id = parseInt(variantId);
            }
            window.upsell.discountOffersInfo[optionId][handle] = product;
            resolve(html);
          },
          ()=>{
            console.log('err');
            resolve(false);
          }
        );
      });

      promisesList.push(promise);
    };

    id++;
    processAddon(id);
  }

  await Promise.all(promisesList);
  const html = Object.values(htmls).join('');

  return `
    <div class="discountOfferBlock__Main">
        ${html}
    </div>
  `;
}

async function renderBlock(data) {
  const { id, checked, addons, text } = data;
  const html = await renderAddons(id, addons);

  return `
    <div class="discountOfferMain">
        <div class="discountOfferContainer">
            <div>
                <div>
                    <input 
                        type="radio" 
                        name="${RADIO_GROUP_ID}" 
                        ${checked ? 'checked' : ''}
                        value="${id}"
                    >
                </div>
                <div>
                    ${text !== '' ? ('Option: ' + text) : text}
                </div>
                ${html}   
            </div>  
        </div>  
    </div>
  `;
}

async function renderBlocks() {
  const options = getOptions();

  const blocksHTML = [];
  let isFirst = false;
  for (const optionId in options) {
    const option = options[optionId];
    const { text } = option[DISCOUNT_OFFER_OPTIONS];
    const addons = getAddons(option);
    if (addons.length !== 0){
      const html = await renderBlock({
        id: optionId,
        checked: isFirst === false ? true : false,
        text,
        addons
      });
      blocksHTML.push(html);
      if (!isFirst) {
        isFirst = true;
      }
    }
  }

  return `
    <div class="discountOfferBlock__Main">
        ${blocksHTML.join('')}
    </div>
  `;
}

function renderButton() {
  return `
    <div class="discountOfferBlockContainer">
        <div class="discountOfferBlockContainer__Button">
            <div class="discountOfferBlockContainer__Text" onclick="window.upsellAddDiscountOffer()">
                GRAB THIS DEAL
            </div>
        </div>
    </div>
  `;
}

async function renderHTML() {
  const blocks = await renderBlocks();

  const main = document.getElementById(CONTAINER_ID);
  main.removeAttribute('class');
  main.innerHTML = `
    <div class="discountOffer__Wrap">
        <div class="discountOffer__Widget">
            ${renderTitle()}
            ${blocks}
            ${renderButton()}
        </div>
    </div>
    `;
}

function getSelectedOfferId() {
  const element = document.querySelector(`input[name="${RADIO_GROUP_ID}"]:checked`);

  if (element){
    return element.value;
  }

  return null;
}

function getSelectedItems() {
  const offerId = getSelectedOfferId();
  const addOns = window.upsell.discountOffersInfo[offerId];
  return Object.values(addOns).map(v => ({ id: v.variant_id || v.variants[0].id, quantity: 1 }));
}

function addDiscountOffer() {
  // Init animation due to get cart items
  setMouseLoading(true);

  const offerId = getSelectedOfferId();

  // get items
  const items = getSelectedItems();

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ items })
  })
    .then(() => {
      setMouseLoading(false);

      // Call all next steps
      const productId = getTargetProductId();
      const offerData = `${productId}_${offerId}`;
      window.location.href = `${getCartPageURL()}?custom_offer=${offerData}`;
    })
    .catch(() => {
      const { options } = getAppProps();

      setMouseLoading(false);
      showDefaultError('Error occurred!', options);
    });
}

function loading() {
  return `
    <div id="${CONTAINER_ID}" class="animated-background">
    </div>
  `;
}

export default function renderDiscountOffer() {
  const { options } = getAppProps();
  const page = PAGE.Product;
  const cartForm = getForm(page, options);

  if (!cartForm) {
    return false;
  }

  const data = getDiscountOfferSettings();
  if (!data) {
    return false;
  }

  if (!isValidOptions(data)){
    return false;
  }

  window.upsell.discountOffersInfo = {};

  injectStyles();
  cartForm.insertAdjacentHTML('afterend', loading());
  renderHTML();
  return true;
}

window.upsellAddDiscountOffer = addDiscountOffer;
